module.exports = __webpack_public_path__ + "static/media/car-white.e242f2d4.svg";